module.exports = __webpack_public_path__ + "img/hexinBanner.3608825c.png";